/**
 * A kebob button that collapses into a tooltip menu
 * (Typically used in the top-right corner of tiles for additional options)
 */
import React from 'react';
import Tooltip from 'deprecated/molecules/triggeredTooltip';
import Icon from 'atoms/icon';
import TooltipContent from 'deprecated/atoms/tooltip/tooltipContent';
import { KebobMenuProps } from './index.d';
import './kebobMenu.css';

const kebob = require('!babel-loader!svg-react-loader?name=Kebob!../../../assets/svg/icKebob.svg');

const KebobMenu = ({ style, children, offsets }: KebobMenuProps) => {
  return (
    <Tooltip
      className="kebobTooltipContainer"
      icon={<Icon glyph={kebob} className="kebobIcon" />}
      theme="grey"
      placement="bottom"
      style={style}
      closeOnOutsideClick
      disableOnHover
      offsets={offsets}
    >
      {children}
    </Tooltip>
  );
};

export default KebobMenu;
